<template>
  <div class="LoginLoading">
    <div class="loading-content">
      <h3>접속중입니다.</h3>
    </div>
    <div class="progress">
      <progress :value="progress" class="m-auto" max="100"></progress>
    </div>
    <div class="loading-content step-message">
      <div>{{ message }}</div>
      <div v-show="max_step > 0" class="align-center">
        ( {{ step }} / {{ max_step }} )
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "LoginLoading",
  data() {
    return {
      interval: {},
      isLoading: false,
      progress: 0,
      reloadCount: 0,
      tables: [],
      table_attributes: [
        {
          name: "config",
          api: this.api.listConfig,
          message: "설정을 불러오고 있습니다.",
        },
        {
          name: "product",
          api: this.api.listProduct,
          message: "제품을 불러오고 있습니다.",
        },
        {
          name: "product_type",
          api: this.api.listProductType,
          message: "제품 구분을 불러오고 있습니다.",
        },
        {
          name: "product_category",
          api: this.api.listProductCategory,
          message: "제품 세부 구분을 불러오고 있습니다.",
        },
        {
          name: "product_price",
          api: this.api.listProductPrice,
          message: "제품 가격을 불러오고 있습니다.",
        },
        {
          name: "product_door_price",
          api: this.api.listProductDoorPrice,
          message: "도어 가격을 불러오고 있습니다.",
        },
        {
          name: "product_door_color_price",
          api: this.api.listProductDoorColorPrice,
          message: "도어 색상 가격을 불러오고 있습니다.",
        },
        {
          name: "customer",
          api: this.api.listCustomer,
          message: "거래처를 불러오고 있습니다.",
        },
        {
          name: "customer_level",
          api: this.api.listCustomerLevel,
          message: "기계 등급을 불러오고 있습니다.",
        },
        {
          name: "client_level",
          api: this.api.listClientLevel,
          message: "거래처 등급을 불러오고 있습니다.",
        },
        {
          name: "customer_glass_level",
          api: this.api.listCustomerGlassLevel,
          message: "유리 등급을 불러오고 있습니다.",
        },
        {
          name: "customer_door_level",
          api: this.api.listCustomerDoorLevel,
          message: "도어 등급을 불러오고 있습니다.",
        },
        {
          name: "user",
          api: this.api.listUser,
          message: "사용자 정보를 불러오고 있습니다.",
        },
        {
          name: "user_group",
          api: this.api.listUserGroup,
          message: "사용자 그룹을 불러오고 있습니다.",
        },
        {
          name: "user_authority",
          api: this.api.listUserAuthority,
          message: "사용자 권한을 불러오고 있습니다.",
        },
        {
          name: "unit",
          api: this.api.listUnit,
          message: "제품 단위를 불러오고 있습니다.",
        },
        {
          name: "account",
          api: this.api.listAccount,
          message: "계좌를 불러오고 있습니다.",
        },
        {
          name: "asset_category",
          api: this.api.listAssetCategory,
          message: "계정을 불러오고 있습니다.",
        },
        {
          name: "sale_type",
          api: this.api.listSaleType,
          message: "판매 구분을 불러오고 있습니다.",
        },
        {
          name: "glass_color",
          api: this.api.listGlassColor,
          message: "유리 색상을 불러오고 있습니다.",
        },
        {
          name: "glass_thickness",
          api: this.api.listGlassThickness,
          message: "유리 두께를 불러오고 있습니다.",
        },
        {
          name: "product_glass_price",
          api: this.api.listProductGlassPrice,
          message: "유리 가격을 불러오고 있습니다.",
        },
        {
          name: "door_color",
          api: this.api.listDoorColor,
          message: "도어 색상을 불러오고 있습니다.",
        },
        {
          name: "branch",
          api: this.api.listBranch,
          message: "부서를 불러오고 있습니다.",
        },
        {
          name: "option",
          api: this.api.listOption,
          message: "옵션을 불러오고 있습니다.",
        },
      ],
      current: null,
      current_table: null,
      current_seq: -1,
      isLoadedBaseData: false,
    };
  },
  created() {
    this.isLoading = true;
    this.progress = 0;
    this.startProgress();
  },
  computed: {
    ...mapGetters(["table_base_data", "userId"]),
    step: function() {
      return this.current_seq + 1;
    },
    max_step: function() {
      return this.tables.length + 1;
    },
    message: function() {
      return this.current
        ? this.current.message
        : "변경 데이터를 확인하고 있습니다.";
    },
  },
  methods: {
    ...mapActions([
      "checkTable",
      "registerLocalDb",
      "saveLocalDb",
      "getsLocalDb",
    ]),
    async startProgress() {
      let tables = this.$store.getters.tables;
      await this.checkTable(tables);
      this.interval = setInterval(() => {
        this.progress = (this.progress + 1) % 100;
      }, 10);
      this.$nextTick(() => {
        this.reloadCount = 0;
        this.loadBaseData();
      });
    },
    loadBaseData() {
      this.reloadCount = 0;
      if (!this.isLoadedBaseData) {
        this.getsLocalDb("table_base_data").then(() => {
          this.isLoadedBaseData = true;
        });
      }
      this.api.listBaseData().then((res) => {
        // 실패하면 10회 재시도 한다.
        if (res.error !== this.system.noError) {
          this.reloadCount++;
          if (this.reloadCount < 10) {
            this.loadBaseData();
            return;
          }
        }
        this.checkTabls(res.data);
      });
    },
    checkTabls(tables) {
      tables.forEach((t) => {
        let data = this.table_base_data.find((d) => d.name === t.name);
        if (!data || data.modified_at !== t.modified_at) {
          this.tables.push(t);
        }
      });
      this.tables.length > 0 ? this.loadTables() : this.loadNotice();
    },
    loadTables() {
      this.current_seq = 0;
      this.loadTable();
    },
    loadTable() {
      this.current_table = this.tables[this.current_seq];
      this.current = this.table_attributes.find(
        (a) => a.name === this.current_table.name
      );
      setTimeout(() => {
        if (this.current) {
          this.current.api().then((res) => {
            if (res.error !== this.system.noError) {
              this.reloadCount++;
              if (this.reloadCount < 10) {
                this.loadTable();
              } else {
                this.$emit("failed");
              }
              return;
            }
            this.registerLocalDb({
              table: "table_" + this.current.name,
              data: res.data,
            });
            this.saveLocalDb({
              table: "table_base_data",
              data: this.current_table,
            });
            if (this.current_seq + 1 >= this.tables.length) {
              this.loadNotice();
            } else {
              this.current_seq++;
              this.loadTable();
            }
          });
        } else {
          this.current_seq++;
        }
      }, 500);
    },
    loadNotice() {
      this.current_seq++;
      (this.current = {
        name: "notice",
        message: "공지사항을 불러오고 있습니다.",
      }),
        this.api.listNoticeByUser(this.userId).then((res) => {
          this.registerLocalDb({
            table: "table_" + this.current.name,
            data: res.data,
          });
          this.successLoad();
        });
    },
    successLoad() {
      this.$emit("finished");
    },
  },
};
</script>
<style lang="scss" scoped>
.LoginLoading {
  margin-top: 80px;
}
progress {
  border-radius: 2px;
  width: 185px;
  height: 10px;
}
progress::-webkit-progress-value {
  background: steelblue;
}
progress::-webkit-progress-bar {
  background: lightgrey;
}
.content {
  margin-top: 20px;
  left: 0;
  width: auto;
}
.step-message {
  font-size: 13px;
}
</style>
{ name: 'user_group', api: this.api.listUserGroup, message: '사용자 정보를
불러오고 있습니다.'},
